<ng-container [ngSwitch]="status">
  <i *ngSwitchCase="'DONE'" class="material-icons">check_circle_outline</i>
  <i *ngSwitchCase="'RETURNED'" class="material-icons grey">replay</i>
  <i *ngSwitchCase="'NOT_STARTED'" class="material-icons NOT_STARTED">trip_origin</i>
  <i *ngSwitchDefault class="material-icons">trip_origin</i>
</ng-container>
